import React, { useState, useRef } from "react";
import { Scatter } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
} from "chart.js";

ChartJS.register(LinearScale, PointElement, Tooltip);

const ClickableGraph = () => {
  const [graphPoints, setGraphPoints] = useState([]); // Store plotted points
  const chartRef = useRef(null); // Reference to the chart

  const handleChartClick = (event) => {

    if (!chartRef.current) return;

    const chart = chartRef.current; // Access the chart instance

    if (!chart.canvas) return; // Ensure canvas exists

    const { left, top, width, height } = chart.canvas.getBoundingClientRect();

    const nativeEvent = event.native || event;  // Try accessing the native event
    const clickX = nativeEvent.clientX - left;
    const clickY = nativeEvent.clientY - top;
  
    // Convert pixel coordinates to chart scale
    const xScale = chart.scales.x;
    const yScale = chart.scales.y;

    if (!xScale || !yScale) return; // Ensure scales exist

    const xValue = xScale.getValueForPixel(clickX);
    const yValue = yScale.getValueForPixel(clickY);

    // Ensure values are within bounds
    if (xValue < 0 || xValue > 10 || yValue < 0 || yValue > 20) return;
    
    // Add the new point
    setGraphPoints((prevPoints) => [...prevPoints, { x: xValue, y: yValue }]);
    console.log('graphPoints:',graphPoints);
  };

  return (
    <div style={{ width: "600px", height: "400px" }}>
      <Scatter
        ref={chartRef}
        data={{
          datasets: [
            {
              label: "Scatter Points",
              data: graphPoints,
              backgroundColor: "red",
              pointRadius: 5,
            },
          ],
        }}
        options={{
          responsive: true,
          onClick: handleChartClick, // Attach click event to Chart.js itself
          scales: {
            x: { type: "linear", min: 0, max: 10 },
            y: { type: "linear", min: 0, max: 20 },
          },
        }}
      />
    </div>
  );
};

export default ClickableGraph;
